import { useEffect, useState } from "react";
import { db } from "../../../../config/firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import "./BookingsList.css";

function BookingsList() {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const bookingQuery = query(
          collection(db, "bookings"),
          orderBy("date", "asc")
        );
        const querySnapshot = await getDocs(bookingQuery);
        setBookings(
          querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        );
      } catch (error) {
        console.error("Error Fetching Bookings:", error);
      }
    };
    fetchBookings();
  }, []);

  return (
    <div className="bookingsListContainer">
      <h2>Bookings List</h2>
      <ul className="bookingsList">
        {bookings.map((booking) => (
          <li key={booking.id} className="bookingListItem">
            {" "}
            Date: {formatDate(booking.date)} Session: {booking.session} People:{" "}
            {booking.people} Name: {booking.name} Email: {booking.email}{" "}
          </li>
        ))}
      </ul>
    </div>
  );
}

function formatDate(dateString) {
  try {
    return new Date(dateString).toLocaleDateString();
  } catch (error) {
    console.error("Error formatting date:", dateString, error);
  }
  return "Invalid Date"; // Default value
}

export default BookingsList;
